import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { HeaderWrapper } from "./components/header";
import { ScrollTop } from "./components/scroll-top";
import { Content } from "./components/content";
import { FooterWrapper } from "./components/footer";
import { Sidebar } from "./components/sidebar";

import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from "../partials";
import { PageDataProvider } from "./core";
import { reInitMenu } from "../helpers";
import { ToolbarWrapper } from "./components/toolbar";
import { useStyleContext } from "../helpers/StyleContext";
import { NovoPedidoProvider } from "../../app/modules/cardapio/context/NovoPedidoContext";
import { NovoPedidoModal } from "../../app/modules/cardapio/components/NovoPedidoModal";
import { PlanLimitBanner } from "../../app/shared/plan-limits/PlanLimitBanner";

const MasterLayout = () => {
  const location = useLocation();
  const { styleState } = useStyleContext();

  useEffect(() => {
    reInitMenu();
  }, [location.key]);

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <NovoPedidoProvider>
          <div
            className="d-flex flex-column flex-root app-root"
            id="kt_app_root"
            style={{ backgroundColor: styleState?.primary_color }}
          >
            <div
              className="app-page flex-column flex-column-fluid"
              id="kt_app_page"
            >
              <HeaderWrapper />
              <div
                className="app-wrapper flex-column flex-row-fluid"
                id="kt_app_wrapper"
              >
                <Sidebar />
                <div
                  className="app-main flex-column flex-row-fluid"
                  id="kt_app_main"
                >
                  <div className="d-flex flex-column flex-column-fluid">
                    <ToolbarWrapper />
                    <Content>
                      <PlanLimitBanner />
                      <Outlet />
                    </Content>
                  </div>
                  <FooterWrapper />
                </div>
              </div>
            </div>
          </div>

          {/* begin:: Drawers */}
          <ActivityDrawer />
          <DrawerMessenger />
          {/* end:: Drawers */}

          {/* begin:: Modals */}
          <InviteUsers />
          <UpgradePlan />
          <NovoPedidoModal />
          {/* end:: Modals */}
          <ScrollTop />
        </NovoPedidoProvider>
      </ThemeModeProvider>
    </PageDataProvider>
  );
};

export { MasterLayout };
